import React, { useEffect, useState } from 'react';
import { Alert, Box, Card, CardContent, Chip, CircularProgress, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import AdminLayout from '../components/AdminLayout';
import api from '../services/api';
import { toast } from 'react-toastify';

interface ContactInquiry {
  id: number;
  name: string;
  email: string;
  phone: string;
  message: string;
  status: string;
  created_at: string;
}

const AdminContactInquiriesPage: React.FC = () => {
  const [items, setItems] = useState<ContactInquiry[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/contact-inquiries/admin')
      .then((response) => setItems(response.data || []))
      .catch((error) => toast.error(error.response?.data?.detail || 'Failed to load contact inquiries'))
      .finally(() => setLoading(false));
  }, []);

  return (
    <AdminLayout currentPage="contact-inquiries">
      <Box sx={{ mb: 3 }}>
        <Typography variant="h4" sx={{ fontWeight: 800, mb: 1 }}>Contact Inbox</Typography>
        <Typography color="text.secondary">Messages submitted through the public Contact Us page.</Typography>
      </Box>
      {loading ? <Box sx={{ py: 8, display: 'flex', justifyContent: 'center' }}><CircularProgress /></Box> : items.length === 0 ? <Alert severity="info">No contact messages yet.</Alert> : (
        <Card><CardContent><TableContainer component={Paper} elevation={0} sx={{ overflowX: 'auto' }}><Table>
          <TableHead><TableRow><TableCell><strong>Visitor</strong></TableCell><TableCell><strong>Phone</strong></TableCell><TableCell><strong>Message</strong></TableCell><TableCell><strong>Status</strong></TableCell><TableCell><strong>Received</strong></TableCell></TableRow></TableHead>
          <TableBody>{items.map((item) => <TableRow key={item.id}>
            <TableCell><Typography fontWeight={700}>{item.name}</Typography><Typography variant="caption">{item.email}</Typography></TableCell>
            <TableCell>{item.phone}</TableCell>
            <TableCell sx={{ minWidth: 280, whiteSpace: 'pre-wrap' }}>{item.message}</TableCell>
            <TableCell><Chip size="small" color={item.status === 'NEW' ? 'warning' : 'success'} label={item.status} /></TableCell>
            <TableCell>{new Date(item.created_at).toLocaleString()}</TableCell>
          </TableRow>)}</TableBody>
        </Table></TableContainer></CardContent></Card>
      )}
    </AdminLayout>
  );
};

export default AdminContactInquiriesPage;
